const SET_NUM_ATTACHMENTS = 'SET_NUM_ATTACHMENTS';
const SET_PROJECT_ATTACHMENTS = 'SET_PROJECT_ATTACHMENTS';

export const setNumAttachments = (numAttachments) => {
  return (dispatch) => {
    dispatch({type: SET_NUM_ATTACHMENTS, numAttachments})
  }
}

export const resetNumAttachments = () => {
  return (dispatch) => {
    const defaultNum = 1;
    dispatch(setNumAttachments(defaultNum));
  }
}

export const addAttachment = () => {
  return (dispatch, getState) => {
    let numAttachments = getState().projects.numAttachments;
    numAttachments++;
    dispatch({type: SET_NUM_ATTACHMENTS, numAttachments})
  }
}

export const removeAttachment = (attachmentId) => {
  return (dispatch, getState) => {
    let numAttachments = getState().projects.numAttachments;
    let project = getState().projects.project;
    let projectAttachments = [];

    if (typeof(project.project_attachments) !== "undefined") {
      projectAttachments = project.project_attachments;

      projectAttachments = projectAttachments.length && projectAttachments.filter(data => {
        if (data.id !== attachmentId) {
          return data;
        }
        return null;
      }).map(projectAttachment => {
        return projectAttachment;
      })

      dispatch({type: SET_PROJECT_ATTACHMENTS, projectAttachments});
    }
    
    if (numAttachments > 0) {
      numAttachments--;
      dispatch({type: SET_NUM_ATTACHMENTS, numAttachments})
    }
  }
}
export const setProjectAttachments = (projectAttachments, successCallback = null) => {
  return (dispatch) => {
    if (projectAttachments && projectAttachments.length) {
      dispatch({type: SET_PROJECT_ATTACHMENTS, projectAttachments});
    } 
    
    if (successCallback) {
      successCallback();
    }
  }
}

export const handleAttachmentValues = (value, attachmentId, attachmentField) => {
  
  return (dispatch, getState) => {
    const project = getState().projects.project;

    if (!Object.keys(project).length) {
      return '';
    }

    let projectAttachments = project.project_attachments;

    if (projectAttachments.length) {
      projectAttachments = projectAttachments.map(attachment => {
        if (attachmentId === attachment.id) {
          attachment[attachmentField] = value;
        }
        return attachment;
      })

      dispatch({type: SET_PROJECT_ATTACHMENTS, projectAttachments});
    }
  }
}